import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SerbiaProjects = () => {
  const { t } = useTranslation();

  const projects = [
    { key: 'projectLapovo', path: '/projects/serbia/lapovo' },
  ];

  return (
    <div className="pt-24 pb-16 px-6 text-[#173861]">
      <button
        onClick={() => window.history.back()}
        className="mb-8 bg-[#50A444] text-white px-4 py-2 rounded hover:bg-green-700 transition"
      >
        ← {t('back')}
      </button>

      <h1 className="text-4xl font-bold text-center mb-6">{t('projectsSerbiaTitle')}</h1>

      <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
        {projects.map((project) => (
          <Link
            key={project.key}
            to={project.path}
            className="group relative block border border-green-600 bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transform transition-transform group-hover:-translate-y-1"
          >
            <img
              src={`/assets/thumbnails/${project.key}.jpg`}
              alt={t(project.key)}
              className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="p-4 text-center bg-white transition-opacity duration-300 group-hover:opacity-80">
              <h2 className="text-xl font-bold text-bg-[#173861] transition">{t(project.key)}</h2>
            </div>
            <div className="absolute bottom-0 left-0 w-full h-2 bg-green-600"></div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SerbiaProjects;
